import type { SVGProps } from 'react';

export function CowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.6 18c0 .664.536 1.2 1.2 1.2H6c.664 0 1.2-.536 1.2-1.2v-3.307q.558.372 1.2.603v.908c0 .33.27.6.6.6s.6-.27.6-.6v-.634a5.3 5.3 0 0 0 1.2 0v.634c0 .33.27.6.6.6s.6-.27.6-.6v-.908q.643-.226 1.2-.603V18c0 .664.536 1.2 1.2 1.2h1.2c.664 0 1.2-.536 1.2-1.2v-6l1.2 1.2v1.856c0 .357.105.702.304.998l1.571 2.359a1.77 1.77 0 0 0 3.21-.638l.761-3.81a1.8 1.8 0 0 0-.3-1.399l-.146-.206V9.3c0-.499-.401-.9-.9-.9s-.9.401-.9.9v.54l-1.984-2.779A5.41 5.41 0 0 0 15.221 4.8H5.4A4.5 4.5 0 0 0 .9 9.3v2.025A2.4 2.4 0 0 0 0 13.2v.66c0 .3.24.54.54.54a2.16 2.16 0 0 0 2.16-2.16V9.3a2.71 2.71 0 0 1 1.144-2.209A3.6 3.6 0 0 0 3.6 8.4zM21 15c0-.33.27-.6.6-.6s.6.27.6.6-.27.6-.6.6-.6-.27-.6-.6M6.247 8.648a.847.847 0 0 1 .6-1.448h6.702a.847.847 0 0 1 .6 1.448l-.878.877A4.33 4.33 0 0 1 10.2 10.8a4.35 4.35 0 0 1-3.071-1.271z" />
    </svg>
  );
}
